<template>
  <v-container fluid style="min-height:400px;">
    <v-layout>
      <v-flex v-if="invalid">
        This invitation is no longer valid.
      </v-flex>
      <v-flex v-else>
        <v-progress-linear class="secondary" indeterminate></v-progress-linear>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data: function () {
    return {
      invalid: false
    }
  },
  components: {
  },
  mounted: async function () {
    const inviteCode = this.$route.params.code;

    try {
      const result = await AuthenticationService.getInvitationWithCode(inviteCode);

      const invitation = result.data;

      if(invitation.TeacherId) {
        this.$router.push({
          path: '/in/join/' + invitation.uuid
        })
      } else {
        this.$router.push({
          path: '/in/signup/' + invitation.uuid
        })
      }
    } catch (err) {
      this.invalid = true;
    }
    

    
  }
}
</script>

<style scoped>

</style>
